// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_submissions.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { ProposalSubmission } from "../../datagateway/v1/proposal_submissions_pb";
/**
 * @generated from message mono.projectdata.v1.FreezeDocumentVersionForSubmissionRequest
 */ export class FreezeDocumentVersionForSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new FreezeDocumentVersionForSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FreezeDocumentVersionForSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FreezeDocumentVersionForSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FreezeDocumentVersionForSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * shirohige id of a volume main document of this project
   *
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FreezeDocumentVersionForSubmissionRequest, "runtime", proto3);
_define_property(FreezeDocumentVersionForSubmissionRequest, "typeName", "mono.projectdata.v1.FreezeDocumentVersionForSubmissionRequest");
_define_property(FreezeDocumentVersionForSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FreezeDocumentVersionForSubmissionResponse
 */ export class FreezeDocumentVersionForSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new FreezeDocumentVersionForSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FreezeDocumentVersionForSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FreezeDocumentVersionForSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FreezeDocumentVersionForSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 2;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string filename = 3;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string sha256 = 4;
   */ _define_property(this, "sha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FreezeDocumentVersionForSubmissionResponse, "runtime", proto3);
_define_property(FreezeDocumentVersionForSubmissionResponse, "typeName", "mono.projectdata.v1.FreezeDocumentVersionForSubmissionResponse");
_define_property(FreezeDocumentVersionForSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordProposalSubmissionRequest
 */ export class RecordProposalSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordProposalSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordProposalSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordProposalSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordProposalSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.datagateway.v1.ProposalSubmission submission = 2;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordProposalSubmissionRequest, "runtime", proto3);
_define_property(RecordProposalSubmissionRequest, "typeName", "mono.projectdata.v1.RecordProposalSubmissionRequest");
_define_property(RecordProposalSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission",
            kind: "message",
            T: ProposalSubmission
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordProposalSubmissionResponse
 */ export class RecordProposalSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordProposalSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordProposalSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordProposalSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordProposalSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalSubmission submission = 1;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordProposalSubmissionResponse, "runtime", proto3);
_define_property(RecordProposalSubmissionResponse, "typeName", "mono.projectdata.v1.RecordProposalSubmissionResponse");
_define_property(RecordProposalSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ProposalSubmission
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalSubmissionsRequest
 */ export class ListProposalSubmissionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalSubmissionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalSubmissionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalSubmissionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalSubmissionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalSubmissionsRequest, "runtime", proto3);
_define_property(ListProposalSubmissionsRequest, "typeName", "mono.projectdata.v1.ListProposalSubmissionsRequest");
_define_property(ListProposalSubmissionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalSubmissionsResponse
 */ export class ListProposalSubmissionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalSubmissionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalSubmissionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalSubmissionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalSubmissionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalSubmission submissions = 1;
   */ _define_property(this, "submissions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalSubmissionsResponse, "runtime", proto3);
_define_property(ListProposalSubmissionsResponse, "typeName", "mono.projectdata.v1.ListProposalSubmissionsResponse");
_define_property(ListProposalSubmissionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: ProposalSubmission,
            repeated: true
        }
    ]));
